"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * PlumbingWorld-3.0
 * PlumbingWorld API
 *
 * Contact: jspencer@juliusspencer.co.nz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetXeroConnectionsGrantTypeEnum = exports.GetSimproTokenGrantTypeEnum = exports.UserApi = void 0;
var runtime = require("../runtime");
var models_1 = require("../models");
/**
 *
 */
var UserApi = /** @class */ (function (_super) {
    __extends(UserApi, _super);
    function UserApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Register trading account for user
     */
    UserApi.prototype.addAccountRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/accounts",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: models_1.NewAccountRegistrationToJSON(requestParameters.newAccountRegistration),
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ProfileResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Register trading account for user
     */
    UserApi.prototype.addAccount = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.addAccountRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Sends an email to PW. NB: A phone number or email must be provided.
     * Send a message as a user to plumbing world
     */
    UserApi.prototype.contactRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.pwRec === null || requestParameters.pwRec === undefined) {
                            throw new runtime.RequiredError('pwRec', 'Required parameter requestParameters.pwRec was null or undefined when calling contact.');
                        }
                        queryParameters = {};
                        if (requestParameters.pwRec !== undefined) {
                            queryParameters['pwRec'] = requestParameters.pwRec;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/contact",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.ContactUsRequestToJSON(requestParameters.contactUsRequest),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Sends an email to PW. NB: A phone number or email must be provided.
     * Send a message as a user to plumbing world
     */
    UserApi.prototype.contact = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.contactRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Sends an email to PW. NB: A phone number or email must be provided.
     * Send a message as a user to plumbing world about backflow product
     */
    UserApi.prototype.contactBackflowRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.pwRec === null || requestParameters.pwRec === undefined) {
                            throw new runtime.RequiredError('pwRec', 'Required parameter requestParameters.pwRec was null or undefined when calling contactBackflow.');
                        }
                        queryParameters = {};
                        if (requestParameters.pwRec !== undefined) {
                            queryParameters['pwRec'] = requestParameters.pwRec;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/contact/backflow",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.ContactUsBackflowRequestToJSON(requestParameters.contactUsBackflowRequest),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Sends an email to PW. NB: A phone number or email must be provided.
     * Send a message as a user to plumbing world about backflow product
     */
    UserApi.prototype.contactBackflow = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.contactBackflowRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Sends an email to PW. NB: A phone number or email must be provided.
     * Send a message as a user to plumbing world shareholding inbox
     */
    UserApi.prototype.contactShareholdingRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.pwRec === null || requestParameters.pwRec === undefined) {
                            throw new runtime.RequiredError('pwRec', 'Required parameter requestParameters.pwRec was null or undefined when calling contactShareholding.');
                        }
                        queryParameters = {};
                        if (requestParameters.pwRec !== undefined) {
                            queryParameters['pwRec'] = requestParameters.pwRec;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/contact/shareholding",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.ContactUsShareholdingRequestToJSON(requestParameters.contactUsShareholdingRequest),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Sends an email to PW. NB: A phone number or email must be provided.
     * Send a message as a user to plumbing world shareholding inbox
     */
    UserApi.prototype.contactShareholding = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.contactShareholdingRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Requests to create an AroFlo Procurement User
     */
    UserApi.prototype.createAroFloProcurementUserRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling createAroFloProcurementUser.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/admin/customer/{customerId}/integration/aroflo/punchout".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.AroFloPunchoutUserFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Requests to create an AroFlo Procurement User
     */
    UserApi.prototype.createAroFloProcurementUser = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createAroFloProcurementUserRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates a trading account with the given information
     */
    UserApi.prototype.createTradingAccountRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/admin/customer",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: models_1.CreateAccountRequestToJSON(requestParameters.createAccountRequest),
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.AccountFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Creates a trading account with the given information
     */
    UserApi.prototype.createTradingAccount = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createTradingAccountRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Deletes the AroFlo punchout user for this customer
     */
    UserApi.prototype.deleteAroFloPunchoutUserRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling deleteAroFloPunchoutUser.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/admin/customer/{customerId}/integration/aroflo/punchout".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Deletes the AroFlo punchout user for this customer
     */
    UserApi.prototype.deleteAroFloPunchoutUser = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteAroFloPunchoutUserRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Delete a user\'s account
     */
    UserApi.prototype.deleteSelfRaw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user",
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Delete a user\'s account
     */
    UserApi.prototype.deleteSelf = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteSelfRaw(initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Deletes a trading account for given account id
     */
    UserApi.prototype.deleteUserTradingAccountRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling deleteUserTradingAccount.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/admin/customer/{customerId}".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Deletes a trading account for given account id
     */
    UserApi.prototype.deleteUserTradingAccount = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteUserTradingAccountRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Deregister a device for a user
     */
    UserApi.prototype.deregisterDeviceRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.id === null || requestParameters.id === undefined) {
                            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling deregisterDevice.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["write_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/device/{id}".replace("{" + "id" + "}", encodeURIComponent(String(requestParameters.id))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Deregister a device for a user
     */
    UserApi.prototype.deregisterDevice = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deregisterDeviceRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get all accounts for user
     */
    UserApi.prototype.getAccountsRaw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/accounts",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ProfileResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get all accounts for user
     */
    UserApi.prototype.getAccounts = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAccountsRaw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Gets the AroFlo punchout user information
     */
    UserApi.prototype.getAroFloPunchoutUserRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling getAroFloPunchoutUser.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/admin/customer/{customerId}/integration/aroflo/punchout".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.AroFloPunchoutUserFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Gets the AroFlo punchout user information
     */
    UserApi.prototype.getAroFloPunchoutUser = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAroFloPunchoutUserRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Gets the AroFlo subscription information for a specified customer
     */
    UserApi.prototype.getAroFloSubscriptionRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling getAroFloSubscription.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/admin/customer/{customerId}/integration/aroflo".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.AroFloSubscriptionFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Gets the AroFlo subscription information for a specified customer
     */
    UserApi.prototype.getAroFloSubscription = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAroFloSubscriptionRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get all accounts for business
     */
    UserApi.prototype.getCustomerAccountsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling getCustomerAccounts.');
                        }
                        if (requestParameters.page === null || requestParameters.page === undefined) {
                            throw new runtime.RequiredError('page', 'Required parameter requestParameters.page was null or undefined when calling getCustomerAccounts.');
                        }
                        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
                            throw new runtime.RequiredError('pageSize', 'Required parameter requestParameters.pageSize was null or undefined when calling getCustomerAccounts.');
                        }
                        queryParameters = {};
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        if (requestParameters.pageSize !== undefined) {
                            queryParameters['pageSize'] = requestParameters.pageSize;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/admin/customer/{customerId}".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.PagedAccountsResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get all accounts for business
     */
    UserApi.prototype.getCustomerAccounts = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCustomerAccountsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Gets the Fergus subscription information for a specified customer
     */
    UserApi.prototype.getFergusSubscriptionRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling getFergusSubscription.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/admin/customer/{customerId}/integration/fergus".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.FergusSubscriptionFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Gets the Fergus subscription information for a specified customer
     */
    UserApi.prototype.getFergusSubscription = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getFergusSubscriptionRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Gets the iTrade subscription information for a specified customer
     */
    UserApi.prototype.getITradeSubscriptionRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling getITradeSubscription.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/admin/customer/{customerId}/integration/itrade".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ITradeSubscriptionFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Gets the iTrade subscription information for a specified customer
     */
    UserApi.prototype.getITradeSubscription = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getITradeSubscriptionRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a link.
     */
    UserApi.prototype.getIntegrationLinkRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling getIntegrationLink.');
                        }
                        if (requestParameters.integrationCompany === null || requestParameters.integrationCompany === undefined) {
                            throw new runtime.RequiredError('integrationCompany', 'Required parameter requestParameters.integrationCompany was null or undefined when calling getIntegrationLink.');
                        }
                        if (requestParameters.action === null || requestParameters.action === undefined) {
                            throw new runtime.RequiredError('action', 'Required parameter requestParameters.action was null or undefined when calling getIntegrationLink.');
                        }
                        queryParameters = {};
                        if (requestParameters.integrationCompany !== undefined) {
                            queryParameters['integrationCompany'] = requestParameters.integrationCompany;
                        }
                        if (requestParameters.action !== undefined) {
                            queryParameters['action'] = requestParameters.action;
                        }
                        if (requestParameters.companyUrl !== undefined) {
                            queryParameters['companyUrl'] = requestParameters.companyUrl;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/admin/customer/{customerId}/integration/link".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.IntegrationResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get a link.
     */
    UserApi.prototype.getIntegrationLink = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getIntegrationLinkRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Gets the Scheduled subscription information for a specified customer
     */
    UserApi.prototype.getScheduledSubscriptionRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling getScheduledSubscription.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/admin/customer/{customerId}/integration/scheduled".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ScheduledSubscriptionFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Gets the Scheduled subscription information for a specified customer
     */
    UserApi.prototype.getScheduledSubscription = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getScheduledSubscriptionRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get shareholder data for the requesting user
     */
    UserApi.prototype.getShareholdersRaw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/shareholders",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.ShareholderFromJSON); })];
                }
            });
        });
    };
    /**
     * Get shareholder data for the requesting user
     */
    UserApi.prototype.getShareholders = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getShareholdersRaw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Receive catalogues from simpro
     */
    UserApi.prototype.getSimproCataloguesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling getSimproCatalogues.');
                        }
                        if (requestParameters.accessToken === null || requestParameters.accessToken === undefined) {
                            throw new runtime.RequiredError('accessToken', 'Required parameter requestParameters.accessToken was null or undefined when calling getSimproCatalogues.');
                        }
                        if (requestParameters.companyUrl === null || requestParameters.companyUrl === undefined) {
                            throw new runtime.RequiredError('companyUrl', 'Required parameter requestParameters.companyUrl was null or undefined when calling getSimproCatalogues.');
                        }
                        if (requestParameters.companyId === null || requestParameters.companyId === undefined) {
                            throw new runtime.RequiredError('companyId', 'Required parameter requestParameters.companyId was null or undefined when calling getSimproCatalogues.');
                        }
                        if (requestParameters.searchTerm === null || requestParameters.searchTerm === undefined) {
                            throw new runtime.RequiredError('searchTerm', 'Required parameter requestParameters.searchTerm was null or undefined when calling getSimproCatalogues.');
                        }
                        queryParameters = {};
                        if (requestParameters.accessToken !== undefined) {
                            queryParameters['accessToken'] = requestParameters.accessToken;
                        }
                        if (requestParameters.companyUrl !== undefined) {
                            queryParameters['companyUrl'] = requestParameters.companyUrl;
                        }
                        if (requestParameters.companyId !== undefined) {
                            queryParameters['companyId'] = requestParameters.companyId;
                        }
                        if (requestParameters.searchTerm !== undefined) {
                            queryParameters['searchTerm'] = requestParameters.searchTerm;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/admin/customer/{customerId}/integration/simpro/catalogues".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.SimproCatalogueFromJSON); })];
                }
            });
        });
    };
    /**
     * Receive catalogues from simpro
     */
    UserApi.prototype.getSimproCatalogues = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSimproCataloguesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Receive companies information from simpro
     */
    UserApi.prototype.getSimproCompaniesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling getSimproCompanies.');
                        }
                        if (requestParameters.accessToken === null || requestParameters.accessToken === undefined) {
                            throw new runtime.RequiredError('accessToken', 'Required parameter requestParameters.accessToken was null or undefined when calling getSimproCompanies.');
                        }
                        if (requestParameters.companyUrl === null || requestParameters.companyUrl === undefined) {
                            throw new runtime.RequiredError('companyUrl', 'Required parameter requestParameters.companyUrl was null or undefined when calling getSimproCompanies.');
                        }
                        queryParameters = {};
                        if (requestParameters.accessToken !== undefined) {
                            queryParameters['accessToken'] = requestParameters.accessToken;
                        }
                        if (requestParameters.companyUrl !== undefined) {
                            queryParameters['companyUrl'] = requestParameters.companyUrl;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/admin/customer/{customerId}/integration/simpro/companies".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.SimproCompanyFromJSON); })];
                }
            });
        });
    };
    /**
     * Receive companies information from simpro
     */
    UserApi.prototype.getSimproCompanies = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSimproCompaniesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Receive job cost centers from simpro
     */
    UserApi.prototype.getSimproJobCostCentersRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling getSimproJobCostCenters.');
                        }
                        if (requestParameters.jobId === null || requestParameters.jobId === undefined) {
                            throw new runtime.RequiredError('jobId', 'Required parameter requestParameters.jobId was null or undefined when calling getSimproJobCostCenters.');
                        }
                        if (requestParameters.jobSectionId === null || requestParameters.jobSectionId === undefined) {
                            throw new runtime.RequiredError('jobSectionId', 'Required parameter requestParameters.jobSectionId was null or undefined when calling getSimproJobCostCenters.');
                        }
                        queryParameters = {};
                        if (requestParameters.jobId !== undefined) {
                            queryParameters['jobId'] = requestParameters.jobId;
                        }
                        if (requestParameters.jobSectionId !== undefined) {
                            queryParameters['jobSectionId'] = requestParameters.jobSectionId;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/admin/customer/{customerId}/integration/simpro/jobcostcenters".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.SimproJobCostCenterFromJSON); })];
                }
            });
        });
    };
    /**
     * Receive job cost centers from simpro
     */
    UserApi.prototype.getSimproJobCostCenters = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSimproJobCostCentersRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Receive sections for a job from simpro
     */
    UserApi.prototype.getSimproJobSectionsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling getSimproJobSections.');
                        }
                        if (requestParameters.jobId === null || requestParameters.jobId === undefined) {
                            throw new runtime.RequiredError('jobId', 'Required parameter requestParameters.jobId was null or undefined when calling getSimproJobSections.');
                        }
                        queryParameters = {};
                        if (requestParameters.jobId !== undefined) {
                            queryParameters['jobId'] = requestParameters.jobId;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/admin/customer/{customerId}/integration/simpro/jobsections".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.SimproJobSectionFromJSON); })];
                }
            });
        });
    };
    /**
     * Receive sections for a job from simpro
     */
    UserApi.prototype.getSimproJobSections = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSimproJobSectionsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Receive jobs for an account from simpro
     */
    UserApi.prototype.getSimproJobsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling getSimproJobs.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/admin/customer/{customerId}/integration/simpro/jobs".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.SimproJobFromJSON); })];
                }
            });
        });
    };
    /**
     * Receive jobs for an account from simpro
     */
    UserApi.prototype.getSimproJobs = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSimproJobsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Receive order number formats from simpro
     */
    UserApi.prototype.getSimproOrderNumberFormatsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling getSimproOrderNumberFormats.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/admin/customer/{customerId}/integration/simpro/orderNumberFormats".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.SimproOrderNumberFormatFromJSON); })];
                }
            });
        });
    };
    /**
     * Receive order number formats from simpro
     */
    UserApi.prototype.getSimproOrderNumberFormats = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSimproOrderNumberFormatsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Gets the simpro invoice subscription status for a specified customer
     */
    UserApi.prototype.getSimproSubscriptionRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling getSimproSubscription.');
                        }
                        if (requestParameters.type === null || requestParameters.type === undefined) {
                            throw new runtime.RequiredError('type', 'Required parameter requestParameters.type was null or undefined when calling getSimproSubscription.');
                        }
                        queryParameters = {};
                        if (requestParameters.type !== undefined) {
                            queryParameters['type'] = requestParameters.type;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/admin/customer/{customerId}/integration/simpro".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.SimproSubscriptionFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Gets the simpro invoice subscription status for a specified customer
     */
    UserApi.prototype.getSimproSubscription = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSimproSubscriptionRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Receive tokens (by exchanging for accessCode) and companies information from simpro
     */
    UserApi.prototype.getSimproTokenRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling getSimproToken.');
                        }
                        if (requestParameters.grantType === null || requestParameters.grantType === undefined) {
                            throw new runtime.RequiredError('grantType', 'Required parameter requestParameters.grantType was null or undefined when calling getSimproToken.');
                        }
                        if (requestParameters.value === null || requestParameters.value === undefined) {
                            throw new runtime.RequiredError('value', 'Required parameter requestParameters.value was null or undefined when calling getSimproToken.');
                        }
                        if (requestParameters.companyUrl === null || requestParameters.companyUrl === undefined) {
                            throw new runtime.RequiredError('companyUrl', 'Required parameter requestParameters.companyUrl was null or undefined when calling getSimproToken.');
                        }
                        queryParameters = {};
                        if (requestParameters.grantType !== undefined) {
                            queryParameters['grantType'] = requestParameters.grantType;
                        }
                        if (requestParameters.value !== undefined) {
                            queryParameters['value'] = requestParameters.value;
                        }
                        if (requestParameters.companyUrl !== undefined) {
                            queryParameters['companyUrl'] = requestParameters.companyUrl;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/admin/customer/{customerId}/integration/simpro/token".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.SimproCompaniesTokenResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Receive tokens (by exchanging for accessCode) and companies information from simpro
     */
    UserApi.prototype.getSimproToken = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSimproTokenRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Receive vendor information from simpro
     */
    UserApi.prototype.getSimproVendorsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling getSimproVendors.');
                        }
                        if (requestParameters.accessToken === null || requestParameters.accessToken === undefined) {
                            throw new runtime.RequiredError('accessToken', 'Required parameter requestParameters.accessToken was null or undefined when calling getSimproVendors.');
                        }
                        if (requestParameters.companyUrl === null || requestParameters.companyUrl === undefined) {
                            throw new runtime.RequiredError('companyUrl', 'Required parameter requestParameters.companyUrl was null or undefined when calling getSimproVendors.');
                        }
                        if (requestParameters.companyId === null || requestParameters.companyId === undefined) {
                            throw new runtime.RequiredError('companyId', 'Required parameter requestParameters.companyId was null or undefined when calling getSimproVendors.');
                        }
                        queryParameters = {};
                        if (requestParameters.accessToken !== undefined) {
                            queryParameters['accessToken'] = requestParameters.accessToken;
                        }
                        if (requestParameters.companyUrl !== undefined) {
                            queryParameters['companyUrl'] = requestParameters.companyUrl;
                        }
                        if (requestParameters.companyId !== undefined) {
                            queryParameters['companyId'] = requestParameters.companyId;
                        }
                        if (requestParameters.searchTerm !== undefined) {
                            queryParameters['searchTerm'] = requestParameters.searchTerm;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/admin/customer/{customerId}/integration/simpro/vendors".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.SimproVendorFromJSON); })];
                }
            });
        });
    };
    /**
     * Receive vendor information from simpro
     */
    UserApi.prototype.getSimproVendors = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSimproVendorsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get all branches for the signed in user
     */
    UserApi.prototype.getUserBranchesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.orderBranch !== undefined) {
                            queryParameters['orderBranch'] = requestParameters.orderBranch;
                        }
                        headerParameters = {};
                        if (requestParameters.ifModifiedSince !== undefined && requestParameters.ifModifiedSince !== null) {
                            headerParameters['If-Modified-Since'] = String(requestParameters.ifModifiedSince);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_branches"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/branches",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.BranchesResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get all branches for the signed in user
     */
    UserApi.prototype.getUserBranches = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getUserBranchesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Gets a list of xero accounts filterable by name or code
     */
    UserApi.prototype.getXeroAccountsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling getXeroAccounts.');
                        }
                        if (requestParameters.accessToken === null || requestParameters.accessToken === undefined) {
                            throw new runtime.RequiredError('accessToken', 'Required parameter requestParameters.accessToken was null or undefined when calling getXeroAccounts.');
                        }
                        if (requestParameters.tenantId === null || requestParameters.tenantId === undefined) {
                            throw new runtime.RequiredError('tenantId', 'Required parameter requestParameters.tenantId was null or undefined when calling getXeroAccounts.');
                        }
                        queryParameters = {};
                        if (requestParameters.accessToken !== undefined) {
                            queryParameters['accessToken'] = requestParameters.accessToken;
                        }
                        if (requestParameters.tenantId !== undefined) {
                            queryParameters['tenantId'] = requestParameters.tenantId;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/admin/customer/{customerId}/integration/xero/accounts".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.XeroAccountFromJSON); })];
                }
            });
        });
    };
    /**
     * Gets a list of xero accounts filterable by name or code
     */
    UserApi.prototype.getXeroAccounts = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getXeroAccountsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Receive tokens and tenant information from xero
     */
    UserApi.prototype.getXeroConnectionsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling getXeroConnections.');
                        }
                        if (requestParameters.grantType === null || requestParameters.grantType === undefined) {
                            throw new runtime.RequiredError('grantType', 'Required parameter requestParameters.grantType was null or undefined when calling getXeroConnections.');
                        }
                        if (requestParameters.value === null || requestParameters.value === undefined) {
                            throw new runtime.RequiredError('value', 'Required parameter requestParameters.value was null or undefined when calling getXeroConnections.');
                        }
                        queryParameters = {};
                        if (requestParameters.grantType !== undefined) {
                            queryParameters['grantType'] = requestParameters.grantType;
                        }
                        if (requestParameters.value !== undefined) {
                            queryParameters['value'] = requestParameters.value;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/admin/customer/{customerId}/integration/xero/connections".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.XeroConnectionsFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Receive tokens and tenant information from xero
     */
    UserApi.prototype.getXeroConnections = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getXeroConnectionsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Gets a list of xero contacts filterable by name
     */
    UserApi.prototype.getXeroContactsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling getXeroContacts.');
                        }
                        if (requestParameters.accessToken === null || requestParameters.accessToken === undefined) {
                            throw new runtime.RequiredError('accessToken', 'Required parameter requestParameters.accessToken was null or undefined when calling getXeroContacts.');
                        }
                        if (requestParameters.tenantId === null || requestParameters.tenantId === undefined) {
                            throw new runtime.RequiredError('tenantId', 'Required parameter requestParameters.tenantId was null or undefined when calling getXeroContacts.');
                        }
                        queryParameters = {};
                        if (requestParameters.accessToken !== undefined) {
                            queryParameters['accessToken'] = requestParameters.accessToken;
                        }
                        if (requestParameters.tenantId !== undefined) {
                            queryParameters['tenantId'] = requestParameters.tenantId;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/admin/customer/{customerId}/integration/xero/contacts".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.XeroContactFromJSON); })];
                }
            });
        });
    };
    /**
     * Gets a list of xero contacts filterable by name
     */
    UserApi.prototype.getXeroContacts = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getXeroContactsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Gets the xero subscription information for a specified customer (without the refresh token)
     */
    UserApi.prototype.getXeroSubscriptionRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling getXeroSubscription.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/admin/customer/{customerId}/integration/xero".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.XeroSubscriptionFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Gets the xero subscription information for a specified customer (without the refresh token)
     */
    UserApi.prototype.getXeroSubscription = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getXeroSubscriptionRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Register a device for a user
     */
    UserApi.prototype.registerDeviceRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.registerDevice === null || requestParameters.registerDevice === undefined) {
                            throw new runtime.RequiredError('registerDevice', 'Required parameter requestParameters.registerDevice was null or undefined when calling registerDevice.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["write_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/device",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: models_1.RegisterDeviceToJSON(requestParameters.registerDevice),
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Register a device for a user
     */
    UserApi.prototype.registerDevice = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.registerDeviceRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Resets the AroFlo punchout user password
     */
    UserApi.prototype.resetAroFloPunchoutUserRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling resetAroFloPunchoutUser.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/admin/customer/{customerId}/integration/aroflo/punchout".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.AroFloPunchoutUserFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Resets the AroFlo punchout user password
     */
    UserApi.prototype.resetAroFloPunchoutUser = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.resetAroFloPunchoutUserRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Exchange current user access token for a shareholding access token to allow easy login
     */
    UserApi.prototype.shareholdingTokenRaw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/shareholdingToken",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.OAuthResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Exchange current user access token for a shareholding access token to allow easy login
     */
    UserApi.prototype.shareholdingToken = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.shareholdingTokenRaw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update status of order email opt-in for user\'s accounts
     */
    UserApi.prototype.updateAccountsEmailOptInRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/accounts/email",
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: models_1.AccountsEmailOptInToJSON(requestParameters.accountsEmailOptIn),
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Update status of order email opt-in for user\'s accounts
     */
    UserApi.prototype.updateAccountsEmailOptIn = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateAccountsEmailOptInRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Updates the AroFlo subscription information for a specified customer
     */
    UserApi.prototype.updateAroFloSubscriptionRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling updateAroFloSubscription.');
                        }
                        if (requestParameters.updateAroFloSubscriptionRequest === null || requestParameters.updateAroFloSubscriptionRequest === undefined) {
                            throw new runtime.RequiredError('updateAroFloSubscriptionRequest', 'Required parameter requestParameters.updateAroFloSubscriptionRequest was null or undefined when calling updateAroFloSubscription.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/admin/customer/{customerId}/integration/aroflo".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: models_1.UpdateAroFloSubscriptionRequestToJSON(requestParameters.updateAroFloSubscriptionRequest),
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.AroFloSubscriptionFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Updates the AroFlo subscription information for a specified customer
     */
    UserApi.prototype.updateAroFloSubscription = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateAroFloSubscriptionRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Updates the date when the last feature dialog was displayed
     */
    UserApi.prototype.updateFeatureDialogRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.featureDialogUpdate === null || requestParameters.featureDialogUpdate === undefined) {
                            throw new runtime.RequiredError('featureDialogUpdate', 'Required parameter requestParameters.featureDialogUpdate was null or undefined when calling updateFeatureDialog.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/featureDialog",
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: models_1.FeatureDialogUpdateToJSON(requestParameters.featureDialogUpdate),
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Updates the date when the last feature dialog was displayed
     */
    UserApi.prototype.updateFeatureDialog = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateFeatureDialogRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Updates the iTrade subscription information for a specified customer
     */
    UserApi.prototype.updateITradeSubscriptionRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling updateITradeSubscription.');
                        }
                        if (requestParameters.updateITradeSubscriptionRequest === null || requestParameters.updateITradeSubscriptionRequest === undefined) {
                            throw new runtime.RequiredError('updateITradeSubscriptionRequest', 'Required parameter requestParameters.updateITradeSubscriptionRequest was null or undefined when calling updateITradeSubscription.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/admin/customer/{customerId}/integration/itrade".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: models_1.UpdateITradeSubscriptionRequestToJSON(requestParameters.updateITradeSubscriptionRequest),
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ITradeSubscriptionFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Updates the iTrade subscription information for a specified customer
     */
    UserApi.prototype.updateITradeSubscription = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateITradeSubscriptionRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update integration status for the prostix account (note this is temporary as it is overwritten daily by JSON import)
     */
    UserApi.prototype.updateIntegrationStatusRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling updateIntegrationStatus.');
                        }
                        if (requestParameters.integrationCompany === null || requestParameters.integrationCompany === undefined) {
                            throw new runtime.RequiredError('integrationCompany', 'Required parameter requestParameters.integrationCompany was null or undefined when calling updateIntegrationStatus.');
                        }
                        if (requestParameters.action === null || requestParameters.action === undefined) {
                            throw new runtime.RequiredError('action', 'Required parameter requestParameters.action was null or undefined when calling updateIntegrationStatus.');
                        }
                        queryParameters = {};
                        if (requestParameters.integrationCompany !== undefined) {
                            queryParameters['integrationCompany'] = requestParameters.integrationCompany;
                        }
                        if (requestParameters.action !== undefined) {
                            queryParameters['action'] = requestParameters.action;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/admin/customer/{customerId}/integration".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.AccountFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Update integration status for the prostix account (note this is temporary as it is overwritten daily by JSON import)
     */
    UserApi.prototype.updateIntegrationStatus = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateIntegrationStatusRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Updates the Scheduled subscription information for a specified customer
     */
    UserApi.prototype.updateScheduledSubscriptionRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling updateScheduledSubscription.');
                        }
                        if (requestParameters.updateScheduledSubscriptionRequest === null || requestParameters.updateScheduledSubscriptionRequest === undefined) {
                            throw new runtime.RequiredError('updateScheduledSubscriptionRequest', 'Required parameter requestParameters.updateScheduledSubscriptionRequest was null or undefined when calling updateScheduledSubscription.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/admin/customer/{customerId}/integration/scheduled".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: models_1.UpdateScheduledSubscriptionRequestToJSON(requestParameters.updateScheduledSubscriptionRequest),
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ScheduledSubscriptionFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Updates the Scheduled subscription information for a specified customer
     */
    UserApi.prototype.updateScheduledSubscription = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateScheduledSubscriptionRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Updates the simpro subscription information for a specified customer
     */
    UserApi.prototype.updateSimproSubscriptionRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling updateSimproSubscription.');
                        }
                        if (requestParameters.updateSimproSubscriptionRequest === null || requestParameters.updateSimproSubscriptionRequest === undefined) {
                            throw new runtime.RequiredError('updateSimproSubscriptionRequest', 'Required parameter requestParameters.updateSimproSubscriptionRequest was null or undefined when calling updateSimproSubscription.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/admin/customer/{customerId}/integration/simpro".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: models_1.UpdateSimproSubscriptionRequestToJSON(requestParameters.updateSimproSubscriptionRequest),
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.SimproSubscriptionFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Updates the simpro subscription information for a specified customer
     */
    UserApi.prototype.updateSimproSubscription = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateSimproSubscriptionRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Updates the trading account with the given information
     */
    UserApi.prototype.updateTradingAccountRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/admin/customer",
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: models_1.AccountToJSON(requestParameters.account),
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.AccountFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Updates the trading account with the given information
     */
    UserApi.prototype.updateTradingAccount = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateTradingAccountRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update a user\'s password
     */
    UserApi.prototype.updateUserPasswordRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/password",
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: models_1.PasswordUpdateToJSON(requestParameters.passwordUpdate),
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Update a user\'s password
     */
    UserApi.prototype.updateUserPassword = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateUserPasswordRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Updates a user perference
     */
    UserApi.prototype.updateUserPreferenceRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/preference",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: models_1.UpdateUserPreferenceRequestToJSON(requestParameters.updateUserPreferenceRequest),
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Updates a user perference
     */
    UserApi.prototype.updateUserPreference = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateUserPreferenceRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Update a user\'s first name, last name, email or mobile. Note that all 4 items need to be sent to give the option to remove an email or mobile number
     */
    UserApi.prototype.updateUserProfileRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.id === null || requestParameters.id === undefined) {
                            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling updateUserProfile.');
                        }
                        if (requestParameters.profileUpdate === null || requestParameters.profileUpdate === undefined) {
                            throw new runtime.RequiredError('profileUpdate', 'Required parameter requestParameters.profileUpdate was null or undefined when calling updateUserProfile.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/{id}/profile".replace("{" + "id" + "}", encodeURIComponent(String(requestParameters.id))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: models_1.ProfileUpdateToJSON(requestParameters.profileUpdate),
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Update a user\'s first name, last name, email or mobile. Note that all 4 items need to be sent to give the option to remove an email or mobile number
     */
    UserApi.prototype.updateUserProfile = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateUserProfileRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Updates the xero subscription information for a specified customer
     */
    UserApi.prototype.updateXeroSubscriptionRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling updateXeroSubscription.');
                        }
                        if (requestParameters.updateXeroSubscriptionRequest === null || requestParameters.updateXeroSubscriptionRequest === undefined) {
                            throw new runtime.RequiredError('updateXeroSubscriptionRequest', 'Required parameter requestParameters.updateXeroSubscriptionRequest was null or undefined when calling updateXeroSubscription.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/admin/customer/{customerId}/integration/xero".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: models_1.UpdateXeroSubscriptionRequestToJSON(requestParameters.updateXeroSubscriptionRequest),
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.XeroSubscriptionFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Updates the xero subscription information for a specified customer
     */
    UserApi.prototype.updateXeroSubscription = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateXeroSubscriptionRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return UserApi;
}(runtime.BaseAPI));
exports.UserApi = UserApi;
/**
    * @export
    * @enum {string}
    */
var GetSimproTokenGrantTypeEnum;
(function (GetSimproTokenGrantTypeEnum) {
    GetSimproTokenGrantTypeEnum["AUTHORIZATION_CODE"] = "authorization_code";
    GetSimproTokenGrantTypeEnum["REFRESH_TOKEN"] = "refresh_token";
})(GetSimproTokenGrantTypeEnum = exports.GetSimproTokenGrantTypeEnum || (exports.GetSimproTokenGrantTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var GetXeroConnectionsGrantTypeEnum;
(function (GetXeroConnectionsGrantTypeEnum) {
    GetXeroConnectionsGrantTypeEnum["AUTHORIZATION_CODE"] = "authorization_code";
    GetXeroConnectionsGrantTypeEnum["REFRESH_TOKEN"] = "refresh_token";
})(GetXeroConnectionsGrantTypeEnum = exports.GetXeroConnectionsGrantTypeEnum || (exports.GetXeroConnectionsGrantTypeEnum = {}));
